/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AgentReadyMessage } from '../models/agent-ready-message';
import { getsessionAgentReadySchema } from '../fn/signal-r-session/getsession-agent-ready-schema';
import { GetsessionAgentReadySchema$Params } from '../fn/signal-r-session/getsession-agent-ready-schema';

@Injectable({ providedIn: 'root' })
export class SignalRSessionService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getsessionAgentReadySchema()` */
  static readonly GetsessionAgentReadySchemaPath = '/api/hubs/session/AgentReady';

  /**
   * AgentReady event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'AgentReady' event delivered via /hubs/session.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getsessionAgentReadySchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getsessionAgentReadySchema$Response(params?: GetsessionAgentReadySchema$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentReadyMessage>> {
    const obs = getsessionAgentReadySchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * AgentReady event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'AgentReady' event delivered via /hubs/session.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getsessionAgentReadySchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getsessionAgentReadySchema(params?: GetsessionAgentReadySchema$Params, context?: HttpContext): Observable<AgentReadyMessage> {
    const resp = this.getsessionAgentReadySchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AgentReadyMessage>): AgentReadyMessage => r.body)
    );
  }

}
